import { render, staticRenderFns } from "./GaleriaVideo.vue?vue&type=template&id=4e107dba&scoped=true&lang=pug"
import script from "./GaleriaVideo.vue?vue&type=script&lang=js"
export * from "./GaleriaVideo.vue?vue&type=script&lang=js"
import style0 from "./GaleriaVideo.styl?vue&type=style&index=0&id=4e107dba&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e107dba",
  null
  
)

export default component.exports